module.exports = __webpack_public_path__ + "media/奖励.c383be8d.wav";